// Shared typography for page hero headings at every breakpoint.
const heroHeading = {
  fontFamily: '"Space Grotesk", "Inter", sans-serif',
  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
  fontWeight: 800,
  lineHeight: 1.15,
  letterSpacing: '-0.03em',
  overflowWrap: 'anywhere',
};

export default heroHeading;
